import { render, staticRenderFns } from "./gs-divider.vue?vue&type=template&id=d0e0cb68&scoped=true&"
import script from "./gs-divider.vue?vue&type=script&lang=ts&"
export * from "./gs-divider.vue?vue&type=script&lang=ts&"
import style0 from "./gs-divider.vue?vue&type=style&index=0&id=d0e0cb68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e0cb68",
  null
  
)

export default component.exports